export default {
   layout: {
        zh: '中文简体',
        en: 'English',
        kr: '한국어',
        tc:'中文繁体',
        th:'泰语ภาษาไทย',
        vn:'Việt Nam'
    },
  footer: { desc: '' },
  menu: {
    home: 'Trang chủ',
    node: 'Nút',
    exchange: 'Đổi tiền',
    staking: 'Đặt cọc',
    me: 'Tôi'
  },
  home: {
    ecological: 'Nút sinh thái',
    more: 'Xem thêm',
    genesis: 'Nút kim cương',
    gold: 'Nút vàng',
    onlyLeft: 'Chỉ còn',
    coin: 'Tỷ lệ tiền xu',
    subscription: 'Mua nút',
    application: 'Khung cảnh ứng dụng sinh thái',
    desc1: 'Đổi điểm trung tâm & thanh toán hàng hóa',
    desc2: 'Đăng ký nút, thu nhập đặt cọc & bỏ phiếu quản trị',
    desc3: 'Đổi tài sản vàng (Ánh xạ RWA)',
    desc4: 'Chia lợi nhuận & khuyến khích cổ tức cho doanh nghiệp',
    desc5: 'Đóng kết phí nền tảng & phân chia lợi nhuận',
    community: 'Quản trị cộng đồng DAO & bỏ phiếu',
    partners: 'Đối tác',
    contact: 'Liên hệ chúng tôi',
    limited: 'Hàng giới hạn',
    mat: 'Vị trí',
    lock: 'Giải phóng khóa kho',
    sky: 'Ngày'
  },
  node: {
    ecology: 'Nút sinh thái',
    meNode: 'Nút của tôi',
    genesis: 'Nút kim cương',
    onlyLeft: 'Chỉ còn',
    coin: 'Tỷ lệ tiền xu',
    subscription: 'Mua nút',
    diamond: 'Nút kim cương',
    bronze: 'Nút đồng',
    revenue: 'Xem thu nhập',
    gold: 'Nút vàng',
    silver: 'Nút bạc',
    noNode: 'Chưa có nút, đăng ký ngay',
    totalCollection: 'Tổng đã nhận',
    toBeClaimed: 'Chờ nhận',
    claimed: 'Nhận',
    totalRelease: 'Tổng giải phóng',
    released: 'Đã giải phóng',
    toBeReleased: 'Chờ giải phóng',
    genesisReleased: 'Giải phóng nút kim cương',
    more: 'Kéo xuống tải thêm',
    nodeSubscription: 'Đăng ký nút',
    receivedTo: 'Nhận vào',
    networkFee: 'Phí mạng',
    confirmSubscription: 'Xác nhận đăng ký',
    progress: 'Giao dịch đang thực hiện',
    executionSuccessful: 'Thực hiện thành công',
    at: 'Tại',
    view: 'Xem tại',
    releaseRecord: 'Lịch sử giải phóng',
    claimRecord: 'Lịch sử nhận',
    nonce: 'Nonce',
    claimIncome: 'Nhận thu nhập',
    quantityClaimed: 'Số lượng nhận',
    pickup: 'Có thể nhận',
    all: 'Tất cả',
    confirmToReceive: 'Xác nhận nhận',
          node0:'Elmas Düğüm',
       node1:'Platin Düğüm',
       node2:'Altın Düğüm',
       node3:'Zümrüt Düğüm',
       node4:'Gümüş Düğüm',
       node5:'Bronz Düğüm',

              release1:'KOL Teşvikleri',
       release2:'Küresel Airdrop',
       release3:'Likidite Havuzu',
       release4:'Kurucu Ekip',
       release5:'Ekosistem Fonu',
       release6:'Kurumlar',
       release7:'Küresel Düğümler',
       release8:'Ekosistem Madencilik Havuzu',
       release9:'Staking Madencilik Havuzu',
       

       success:'Başarı',
       error:'Başarısızlık',
       nocount:'Bu düğüm tükendi'
  },
  exchange: {
    at: 'Tại',
    view: 'Xem tại',
    more: 'Thêm',
    indicator: 'Chỉ số',
    market: 'Đổi theo giá thị trường',
    payment: 'Thanh toán',
    all: 'Tất cả',
    received: 'Đã nhận',
    slippage: 'Slippage',
    minimum: 'Số lượng nhận tối thiểu',
    cost: 'Phí mạng',
    confirmExchange: 'Xác nhận đổi',
    record: 'Lịch sử',
    completed: 'Đã hoàn thành',
    error: 'Thất bại',
    downMore: 'Kéo xuống tải thêm',
    price: 'Giá',
    progress: 'Giao dịch đang thực hiện',
    wallet: 'Ví khởi tạo',
    refuse: 'Từ chối',
    nodeSubscription: 'Đăng ký nút',
    executionSuccessful: 'Thực hiện thành công',
    nonce: 'Nonce',
    confirm: 'Xác nhận'
  },
  me: {
    assets: 'Tổng tài sản',
    recharge: 'Nạp tiền',
    transfer: 'Chuyển ra',
    record: 'Lịch sử'
  },
  recharge: {
    recharge: 'Nạp tiền',
    title: 'Địa chỉ này chỉ hỗ trợ tài sản liên quan NEX',
    address: 'Địa chỉ nhận tiền',
    copy: 'Sao chép',
    share: 'Chia sẻ'
  },
  record: {
    record: 'Lịch sử',
    all: 'Tất cả',
    recharge: 'Nạp tiền',
    transfer: 'Chuyển ra',
    claimed: 'Nhận'
  },
  transfer: {
    transfer: 'Chuyển ra',
    address: 'Địa chỉ chuyển ra',
    transferCoin: 'Token chuyển tiền',
    pla: 'Nhập địa chỉ chuyển ra',
    network: 'Mạng chuyển tiền',
    mainNetwork: 'Chọn mainnet',
    transferAmount: 'Số tiền chuyển ra',
    withdraw: 'Rút tối thiểu 20',
    all: 'Tất cả',
    balance: 'Số dư khả dụng',
    tips: 'Kiểm tra địa chỉ & mạng chuyển ra cẩn thận, tài sản không thể truy hồi sau khi lên chuỗi',
    amountReceived: 'Số lượng nhận được',
    free: 'Phí mạng'
  }
};